import { observer } from 'mobx-react-lite';
import { t } from 'utilities/TranslationUtils';

export const NoPermissions = observer(() => {
  return (
    <div className='no-permissions-page'>
      <div className='row'>
        <div className='col-12'>
          <div className='welcome-text'>
            <p>{t('noPermissions.Title')}</p>
          </div>
        </div>
      </div>
      <div className='row'>
        <div className='col-12'>
          <div className='wrapper no-permissions'>
            <div className='row flex-column-reverse flex-md-row'>
              <div className='col-md-6 col-sm-12'>
                <p>
                  You can not access any TrackMan web portal features because your account is not associated with any organization. Contact
                  your TrackMan administrator to be added to your organization.
                </p>
              </div>
              <div className='col-md-6 col-sm-12'>
                <img className='no-permissions-img' src='/assets/img/imac-ipad@3x.png' alt='' />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
});

export default NoPermissions;
